import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Signin from "./pages/authentication/signin";
import { Shop } from "@mui/icons-material";
import ForgetPassword from "./pages/authentication/signin/ForgetPassword";
import OtpVerify from "./pages/authentication/signin/OtpVerify";
import ConfirmPassword from "./pages/authentication/signin/ConfirmPassword";
import ResetSuccessful from "./pages/authentication/signin/ResetSuccessful";
import Role from "./pages/Masters/Role/Role";
import IndustryMaster from "./pages/Masters/IndustryMaster/IndustryMaster";
import ClientMaster from "./pages/Masters/ClientMaster/ClientMaster";
import UserMaster from "./pages/Masters/UserMaster/usermaster";
import BulkuploadCandidate from "./pages/BulKcandidate/bulkcandidate";
import Shortlist from "./pages/HiringProcess/shortlisted/shortlist";
import Hiringqueue from "./pages/HiringProcess/hiringqueue/hiringqueue";
import Interview from "./pages/HiringProcess/interviewed/interview";
import Onboarded from "./pages/HiringProcess/onboard/onboard";
import InvoiceEligible from "./pages/HiringProcess/invoiceeligible/invoiceeligible";
import PositionMaster from "./pages/Masters/PositionMaster/positionmaster";
import Dashboard from "./pages/dashboard/Dashboard";
import ActivityLog from "./pages/Utils/ActivityLog";
import Reports from "./pages/Reports/Reports";

const routes = [
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Sign in",
        key: "sign-in",
        route: "/sign-in",
        component: <Signin />,
      },
    ],
  },
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Forget Password",
        key: "forget-password",
        route: "/forget-password",
        component: <ForgetPassword />,
      },
    ],
  },
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Otp Verify",
        key: "otp-verify",
        route: "/otp-verify",
        component: <OtpVerify />,
      },
    ],
  },
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "Confirm Password",
        key: "confirm-password",
        route: "/confirm-password",
        component: <ConfirmPassword />,
      },
    ],
  },
  {
    name: "Authentication",
    key: "authentication",
    collapse: [
      {
        name: "ResetSuccessful",
        key: "reset-successful",
        route: "/reset-successful",
        component: <ResetSuccessful />,
      },
    ],
  },
  {
    type: "collapse",
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 10H7C7.55 10 8 9.55 8 9V1C8 0.45 7.55 0 7 0H1C0.45 0 0 0.45 0 1V9C0 9.55 0.45 10 1 10ZM1 18H7C7.55 18 8 17.55 8 17V13C8 12.45 7.55 12 7 12H1C0.45 12 0 12.45 0 13V17C0 17.55 0.45 18 1 18ZM11 18H17C17.55 18 18 17.55 18 17V9C18 8.45 17.55 8 17 8H11C10.45 8 10 8.45 10 9V17C10 17.55 10.45 18 11 18ZM10 1V5C10 5.55 10.45 6 11 6H17C17.55 6 18 5.55 18 5V1C18 0.45 17.55 0 17 0H11C10.45 0 10 0.45 10 1Z"
          fill="white"
        />
      </svg>  
    ),
    name: "DashBoard",
    action: ["Export"],
    roleAcess: true,
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Masters",
    key: "Masters",
    roleAcess: true,
    icon: (
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.616 14.5V16.616C13.616 16.718 13.6543 16.8077 13.731 16.885C13.8077 16.9617 13.8973 17 14 17C14.1027 17 14.1927 16.9617 14.27 16.885C14.3473 16.8083 14.3853 16.7183 14.384 16.615V14.5H16.5C16.6027 14.5 16.6927 14.4617 16.77 14.385C16.846 14.3077 16.884 14.2177 16.884 14.115C16.884 14.013 16.8457 13.9233 16.769 13.846C16.6923 13.7693 16.6027 13.731 16.5 13.731H14.384V11.615C14.384 11.513 14.3457 11.4233 14.269 11.346C14.1923 11.2693 14.1027 11.231 14 11.231C13.8973 11.231 13.8073 11.2693 13.73 11.346C13.6527 11.4227 13.6147 11.5127 13.616 11.616V13.731H11.5C11.3973 13.731 11.3073 13.7693 11.23 13.846C11.154 13.9233 11.116 14.0133 11.116 14.116C11.116 14.218 11.1543 14.3077 11.231 14.385C11.3077 14.4617 11.3973 14.5 11.5 14.5H13.616ZM14 18.116C12.886 18.116 11.941 17.7277 11.165 16.951C10.3883 16.175 10 15.23 10 14.116C10 13.002 10.3883 12.0567 11.165 11.28C11.9417 10.5033 12.8867 10.1153 14 10.116C15.1133 10.1167 16.0587 10.5047 16.836 11.28C17.6133 12.0553 18.0013 13.0007 18 14.116C18 15.2293 17.612 16.1743 16.836 16.951C16.0587 17.7277 15.1133 18.116 14 18.116ZM4 4.73H12C12.142 4.73 12.2607 4.682 12.356 4.586C12.452 4.49 12.5 4.371 12.5 4.229C12.5 4.087 12.452 3.96833 12.356 3.873C12.26 3.77767 12.1413 3.73033 12 3.731H4C3.858 3.731 3.73933 3.779 3.644 3.875C3.54867 3.971 3.50067 4.09 3.5 4.232C3.49933 4.374 3.54733 4.49267 3.644 4.588C3.74067 4.68333 3.85933 4.73067 4 4.73ZM1.616 16C1.17133 16 0.791 15.8417 0.475 15.525C0.159 15.2083 0.000666667 14.8287 0 14.386V1.615C0 1.171 0.158333 0.791 0.475 0.475C0.791667 0.159 1.17167 0.000666667 1.615 0H14.385C14.829 0 15.209 0.158333 15.525 0.475C15.841 0.791667 15.9993 1.17167 16 1.615V6.623C16 6.87433 15.907 7.07 15.721 7.21C15.535 7.35 15.3197 7.39533 15.075 7.346C14.907 7.30133 14.7323 7.271 14.551 7.255C14.3697 7.239 14.186 7.23067 14 7.23C13.6627 7.23 13.3347 7.25667 13.016 7.31C12.698 7.36333 12.385 7.43867 12.077 7.536C12.0023 7.51933 11.919 7.509 11.827 7.505C11.7357 7.501 11.6523 7.499 11.577 7.499H4C3.858 7.499 3.73933 7.547 3.644 7.643C3.54867 7.739 3.50067 7.858 3.5 8C3.49933 8.142 3.54733 8.26067 3.644 8.356C3.74067 8.45133 3.85933 8.49933 4 8.5H10.087C9.58167 8.84733 9.13767 9.255 8.755 9.723C8.37233 10.191 8.05733 10.7063 7.81 11.269H4C3.858 11.269 3.73933 11.317 3.644 11.413C3.548 11.509 3.5 11.628 3.5 11.77C3.5 11.912 3.548 12.0307 3.644 12.126C3.74 12.2213 3.85867 12.269 4 12.269H7.46C7.388 12.551 7.33167 12.8353 7.291 13.122C7.251 13.4087 7.231 13.7013 7.231 14C7.231 14.1667 7.23467 14.3423 7.242 14.527C7.25 14.7117 7.27 14.9007 7.302 15.094C7.334 15.326 7.28233 15.535 7.147 15.721C7.01167 15.907 6.82867 16 6.598 16H1.616Z"
          fill="white"
        />
      </svg>
    ),
    collapse: [
      {
        name: "Industry Master",
        action: ["Edit", "View", "Delete", "Create"],
        roleAcess: true,
        key: "industry",
        route: "/master/industry",
        component: <IndustryMaster />,
      },
      {
        name: "Client Master",
        action: ["Edit", "View", "Delete", "Create", "Export"],
        roleAcess: true,
        key: "client",
        route: "/master/client",
        component: <ClientMaster />,
      },
      {
        name: "Position Master",
        action: ["Edit", "View", "Delete", "Create", "Export"],
        roleAcess: true,
        key: "position",
        route: "/master/position",
        component: <PositionMaster />,
      },
      {
        name: "Role Master",
        action: ["Edit", "View", "Delete", "Create"],
        roleAcess: true,
        key: "role",
        route: "/master/role",
        component: <Role />,
      },
      {
        name: "User Master",
        action: ["Edit", "View", "Delete", "Create", "Export"],
        key: "user",
        route: "/master/user",
        component: <UserMaster />,
      },
    ],
  },
  {
    type: "collapse",
    icon: (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.63827 13.976C9.82999 13.976 10.0139 13.8999 10.1494 13.7643C10.285 13.6287 10.3611 13.4449 10.3611 13.2532V2.67709L11.9804 4.56715C12.1051 4.71286 12.2826 4.80304 12.4739 4.81786C12.6651 4.83268 12.8544 4.77093 13.0001 4.64618C13.1458 4.52144 13.236 4.34392 13.2508 4.15269C13.2656 3.96145 13.2039 3.77216 13.0791 3.62646L10.1877 0.25306C10.1198 0.173704 10.0355 0.109991 9.9407 0.066306C9.84587 0.0226208 9.74269 0 9.63827 0C9.53386 0 9.43068 0.0226208 9.33584 0.066306C9.241 0.109991 9.15675 0.173704 9.08889 0.25306L6.19741 3.62646C6.13564 3.6986 6.08869 3.78221 6.05923 3.8725C6.02978 3.96279 6.01839 4.058 6.02573 4.15269C6.03307 4.24738 6.05899 4.3397 6.10201 4.42437C6.14502 4.50905 6.2043 4.58442 6.27644 4.64618C6.34859 4.70795 6.4322 4.7549 6.52249 4.78436C6.61278 4.81382 6.70799 4.8252 6.80268 4.81786C6.89737 4.81052 6.98969 4.7846 7.07436 4.74159C7.15903 4.69857 7.23441 4.6393 7.29617 4.56715L8.9154 2.67805V13.2532C8.9154 13.6522 9.23925 13.976 9.63827 13.976Z"
          fill="white"
        />
        <path
          d="M13.4936 7.47021C12.817 7.47021 12.4787 7.47021 12.2348 7.6331C12.13 7.70326 12.0399 7.79331 11.9698 7.89815C11.8069 8.142 11.8069 8.48031 11.8069 9.15691V13.2532C11.8069 13.8283 11.5784 14.3799 11.1717 14.7866C10.765 15.1933 10.2134 15.4218 9.63827 15.4218C9.06312 15.4218 8.51153 15.1933 8.10483 14.7866C7.69814 14.3799 7.46966 13.8283 7.46966 13.2532V9.15691C7.46966 8.48031 7.46966 8.142 7.30677 7.89815C7.23662 7.79331 7.14657 7.70326 7.04172 7.6331C6.79787 7.47021 6.45957 7.47021 5.78296 7.47021C3.05726 7.47021 1.69344 7.47021 0.847204 8.31742C-5.74486e-08 9.16366 0 10.5255 0 13.2522V14.216C0 16.9437 -5.74486e-08 18.3056 0.847204 19.1528C1.69344 20 3.05726 20 5.78296 20H13.4936C16.2193 20 17.5831 20 18.4293 19.1528C19.2756 18.3056 19.2765 16.9427 19.2765 14.217V13.2532C19.2765 10.5265 19.2765 9.16366 18.4293 8.31742C17.5831 7.47021 16.2193 7.47021 13.4936 7.47021Z"
          fill="white"
        />
      </svg>
    ),
    action: ["Delete", "Upload"],
    name: "Bulk Candidate Upload",
    key: "bulk-upload-candidate",
    route: "/bulk-upload-candidate",
    component: <BulkuploadCandidate />,
    roleAcess: true,
    noCollapse: true,
    protected: true,
  },
  {
    type: "collapse",
    name: "Candidate Tracking",
    key: "Candidate Tracking",
    roleAcess: true,
    icon: (
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.51667 2.57126C6.51667 3.25321 6.24801 3.90722 5.76979 4.38942C5.29157 4.87163 4.64297 5.14253 3.96667 5.14253C3.29036 5.14253 2.64176 4.87163 2.16354 4.38942C1.68533 3.90722 1.41667 3.25321 1.41667 2.57126C1.41667 1.88932 1.68533 1.23531 2.16354 0.753106C2.64176 0.2709 3.29036 2.73138e-07 3.96667 2.73138e-07C4.64297 2.73138e-07 5.29157 0.2709 5.76979 0.753106C6.24801 1.23531 6.51667 1.88932 6.51667 2.57126ZM1.13333 5.71392C0.832755 5.71392 0.544487 5.83432 0.331946 6.04863C0.119404 6.26295 0 6.55362 0 6.8567V11.9992C-1.09774e-08 12.5245 0.102601 13.0446 0.301944 13.5299C0.501288 14.0151 0.793471 14.4561 1.16181 14.8275C1.53015 15.1989 1.96743 15.4935 2.44869 15.6945C2.92995 15.8955 3.44576 15.999 3.96667 15.999C4.48758 15.999 5.00339 15.8955 5.48464 15.6945C5.9659 15.4935 6.40318 15.1989 6.77152 14.8275C7.13986 14.4561 7.43205 14.0151 7.63139 13.5299C7.83073 13.0446 7.93333 12.5245 7.93333 11.9992V6.8567C7.93333 6.55362 7.81393 6.26295 7.60139 6.04863C7.38885 5.83432 7.10058 5.71392 6.8 5.71392H1.13333ZM7.65 2.57126C7.65 3.31407 7.43467 4.00546 7.06067 4.58599C7.52873 4.64085 7.9526 4.8374 8.2892 5.13453C8.35796 5.1391 8.42822 5.14177 8.5 5.14253C8.90178 5.1425 9.29786 5.04674 9.65597 4.86306C10.0141 4.67937 10.3241 4.41296 10.5607 4.08554C10.7973 3.75813 10.9539 3.37896 11.0176 2.97896C11.0813 2.57895 11.0503 2.16943 10.9273 1.78377C10.8042 1.39811 10.5925 1.04723 10.3095 0.759721C10.0264 0.472214 9.67997 0.25622 9.29841 0.129345C8.91684 0.00246962 8.51094 -0.0316958 8.11379 0.0296331C7.71664 0.0909621 7.33949 0.24605 7.01307 0.482255C7.41427 1.07765 7.65 1.79646 7.65 2.57126ZM7.36667 15.8333C7.90163 15.3508 8.32957 14.7599 8.62252 14.0992C8.91546 13.4385 9.06681 12.7229 9.06667 11.9992V6.8567C9.06667 6.44073 8.9556 6.0499 8.76293 5.71392H11.3333C11.6339 5.71392 11.9222 5.83432 12.1347 6.04863C12.3473 6.26295 12.4667 6.55362 12.4667 6.8567V11.9992C12.4668 12.6223 12.3226 13.2367 12.0456 13.7936C11.7685 14.3505 11.3663 14.8345 10.8709 15.2069C10.3756 15.5793 9.80079 15.8298 9.19238 15.9386C8.58398 16.0473 7.9588 16.0113 7.36667 15.8333ZM12.1833 2.57126C12.1833 3.31407 11.968 4.00546 11.594 4.58599C12.0621 4.64085 12.4859 4.8374 12.8225 5.13453C12.8913 5.1391 12.9616 5.14177 13.0333 5.14253C13.4351 5.1425 13.8312 5.04674 14.1893 4.86306C14.5474 4.67937 14.8574 4.41296 15.094 4.08554C15.3306 3.75813 15.4872 3.37896 15.5509 2.97896C15.6146 2.57895 15.5837 2.16943 15.4606 1.78377C15.3376 1.39811 15.1259 1.04723 14.8428 0.759721C14.5597 0.472214 14.2133 0.25622 13.8317 0.129345C13.4502 0.00246962 13.0443 -0.0316958 12.6471 0.0296331C12.25 0.0909621 11.8728 0.24605 11.5464 0.482255C11.9476 1.07765 12.1833 1.79646 12.1833 2.57126ZM11.9 15.8333C12.435 15.3508 12.8629 14.7599 13.1558 14.0992C13.4488 13.4385 13.6001 12.7229 13.6 11.9992V6.8567C13.6 6.44073 13.4889 6.0499 13.2963 5.71392H15.8667C16.1672 5.71392 16.4555 5.83432 16.6681 6.04863C16.8806 6.26295 17 6.55362 17 6.8567V11.9992C17.0002 12.6223 16.856 13.2367 16.5789 13.7936C16.3019 14.3505 15.8996 14.8345 15.4043 15.2069C14.9089 15.5793 14.3341 15.8298 13.7257 15.9386C13.1173 16.0473 12.4921 16.0113 11.9 15.8333Z"
          fill="white"
        />
      </svg>
    ),
    collapse: [
      // {
      //   name: "Hiring Queue",

      //   action: ["View", "Export"],

      //   roleAcess: true,

      //   key: "hiring-queue",

      //   route: "Hiring-Process/hiring-queue",

      //   component: <Hiringqueue />,
      // },

      {
        name: "Shortlisted",

        action: ["Edit", "View", "Delete", "Create", "Export"],

        roleAcess: true,

        key: "shortlist",

        route: "Hiring-Process/shortlist",

        component: <Shortlist />,
      },

      {
        name: "Interviewed",

        action: ["Edit", "View", "Delete", "Export"],

        roleAcess: true,

        key: "interviewed",

        route: "Hiring-Process/interviewed",

        component: <Interview />,
      },

      {
        name: "Onboarded",

        action: ["Edit", "View", "Delete", "Export"],

        roleAcess: true,

        key: "onboarded",

        route: "Hiring-Process/onboarded",

        component: <Onboarded />,
      },

      // {
      //   name: "Invoice Eligible Candidates",

      //   action: ["View", "Export"],

      //   roleAcess: true,

      //   key: "invoice",

      //   route: "Hiring-Process/invoice",

      //   component: <InvoiceEligible />,
      // },
    ],
  },
  // {
  //   type: "collapse",
  //   icon: (
  //     <svg
  //       width="18"
  //       height="18"
  //       viewBox="0 0 18 18"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM6 14H4V7H6V14ZM10 14H8V4H10V14ZM14 14H12V10H14V14Z"
  //         fill="white"
  //       />
  //     </svg>
  //   ),
  //   name: "Reports",
  //   action: ["Export"],
  //   roleAcess: true,
  //   key: "Reports",
  //   route: "/Reports",
  //   component: <Reports />,
  //   noCollapse: true,
  //   protected: true,
  // },
  {
    type: "collapse",
    name: "Activity Log",
    key: "activityLog",
    route: "/activityLog",
    component: <ActivityLog />,
    noCollapse: true,
    protected: true,
  },
];
export default routes;
